import React from "react";

// reactstrap components
import {
    Alert,
    Button,
    Card,
    CardHeader,
    Col,
    FormGroup,
    Input,
    InputGroupAddon,
    InputGroupText,
    InputGroup,
    Container,
    Row,
    CardBody,
} from "reactstrap";
// core components
import Barcode from 'react-barcode';
import ReactToPrint from 'react-to-print';
import Header from "components/Headers/CreditHistoryHeader";
// var Barcode = require('react-barcode');

class BarcodeGenerator extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            barcodes: [],
            searchBarBarcode: undefined,
        };
    }

    handleInputChanged(e) {
        this.setState({
            searchBarBarcode: e.target.value
        })
    }

    onKeyUp(e) {
        delete this.state.errorMessage;
        var charCode = (typeof e.which === "undefined") ? e.keyCode : e.which;
        var val = e.target.value
        if (charCode === 13) {
            this.setState(prevState => {
                let barcodes = Object.assign([], prevState.barcodes);
                barcodes.push(val)
                return { barcodes, searchBarBarcode: '' };
            })
        }
    }

    render() {
        return (
            <>
                <Header />
                {/* Page content */}
                <Container className="mt--7" fluid>
                    {/* Table */}
                    <Row>
                        <div className="col">
                            <Card className="shadow">
                                <CardHeader className="border-0">
                                    <Row className="mt-3">
                                        <Col xs={12}>
                                            <FormGroup>
                                                <InputGroup className="input-group-alternative mb-4">
                                                    <InputGroupAddon addonType="prepend">
                                                        <InputGroupText>
                                                            <i className="ni ni-zoom-split-in" />
                                                        </InputGroupText>
                                                    </InputGroupAddon>
                                                    <Input
                                                        className="form-control-alternative"
                                                        placeholder="Barcode"
                                                        value={this.state.searchBarBarcode}
                                                        onKeyUp={this.onKeyUp.bind(this)}
                                                        onChange={this.handleInputChanged.bind(this)}
                                                        type="text"
                                                    />
                                                </InputGroup>
                                            </FormGroup>
                                        </Col>
                                    </Row>
                                </CardHeader>
                                {(this.state.barcodes?.length > 0) && (
                                    <CardBody>
                                        <div>
                                            <ReactToPrint
                                                trigger={() => {
                                                    // NOTE: could just as easily return <SomeComponent />. Do NOT pass an `onClick` prop
                                                    // to the root node of the returned component as it will be overwritten.
                                                    return <Button
                                                        color="info"
                                                        type="button"
                                                        size="sm"
                                                        block>
                                                        Cetak barcode</Button>;
                                                }}
                                                content={() => this.componentRef}
                                            />
                                            <div ref={el => (this.componentRef = el)}>
                                                {this.state.barcodes.map(barcode => (
                                                    <Barcode value={barcode} />
                                                ))}
                                            </div>
                                        </div>
                                    </CardBody>
                                )}
                            </Card>
                        </div>
                    </Row>
                </Container>
            </>
        );
    }
}

export default BarcodeGenerator;
